// ISO 4217 codes the product deals in. AUD is the only one slice 1 needs; the type exists so that
// currency is explicit on every amount (CB-CONV §3.4) rather than assumed.
export const CURRENCY_CODES = ['AUD', 'NZD', 'USD', 'GBP', 'EUR'];
export function isCurrencyCode(value) {
    return CURRENCY_CODES.includes(value);
}
/** Minor units per major unit. Every currency above has two decimal places. */
export const MINOR_UNITS_PER_MAJOR = 100n;
//# sourceMappingURL=currency.js.map